import React from "react";
import UploadContact from "./UploadContact";

function AddOrUploadContactForm({
  selectUploadedContacts,
  setSelectUploadedContacts,
   setActiveTab,
    manuallyAddedContacts,          
    setManuallyAddedContacts
}) {
  return (
    <div>
      <UploadContact
        // onBack={() => setView("home")}
         setActiveTab={ setActiveTab}
        contacts={selectUploadedContacts}
        setContacts={setSelectUploadedContacts}
         manuallyAddedContacts={manuallyAddedContacts}
          setManuallyAddedContacts={setManuallyAddedContacts}
      />
    </div>
  );
}

export default AddOrUploadContactForm;
